import * as React from 'react';
import { Modal, ModalBody } from 'reactstrap';

interface IModalLegalProps {
  open: boolean;
  toggle: any;
  title: string;
  data: string[];
}

export default function ModalExamples(props: IModalLegalProps) {
  const { open = true, title, data, toggle } = props;

  return (
    <Modal modalClassName="format-new-modal" isOpen={open} size="lg" fade={false}>
      <div className="modal-header">
        <div className="close-modal-header w-100 d-flex text-align-left justify-content-between">
            <img
                src="https://sfestaticos.blob.core.windows.net/pmc/salud/assets/svg/salud-complementario/Icon_chevron.svg"
                alt=""
                onClick={toggle(false)}
            />
            <img 
                src="https://sfestaticos.blob.core.windows.net/pmc/salud/assets/svg/salud-complementario/Action%20Group.svg"
                alt=""
                onClick={toggle(false)}
            />
        </div>
        <h4 className="modal-title px-20">{title}</h4>
      </div>
      <ModalBody className="px-16">
        <ul>
            {data.map(d => <li>{d}</li>)}
        </ul>
      </ModalBody>
    </Modal>
  );
}
